import { useState, useCallback } from 'react'

import { SensorId } from '@/types/domain'

import { authHeader, notifyError, notifySuccess } from '../../api/'
import { languageConstants as LC } from '../../constants/'
import { refreshToken } from '../auth/'

const { REACT_APP_API_URL } = import.meta.env

export const useImportSensorData = () => {
  const [isLoading, setLoading] = useState(false)
  const [isError, setError] = useState(null)

  const importSensorData = useCallback(async (data, id: SensorId) => {
    setError(null)
    if (!id) {
      const message = LC.SENSOR_DEVICE_REQUIRED || 'SENSOR_DEVICE_REQUIRED'
      setError(message)
      notifyError(message)
      return null
    }

    setLoading(true)
    try {
      await refreshToken()

      const url = `${REACT_APP_API_URL}/sensors/admin/sensors/${id}/import`
      const options = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      }
      const response = await fetch(url, options)
      if (!response.ok) {
        const text = await response.text()
        throw new Error(text || `HTTP ${response.status}`)
      }

      const result = await response.json()
      notifySuccess(LC.SENSOR_UPDATED)
      return result
    } catch (error) {
      const message = error?.message || 'Fehler beim Import'
      setError(message)
      notifyError(message)
      return null
    } finally {
      setLoading(false)
    }
  }, [])

  return { importSensorData, isLoading, isError }
}
